/**
 * Mobil sticky sepet cubugu + alttan acilan sepet modali.
 *
 * Kaynak dogruluk: sections/cart-drawer.liquid. Her sepet degisiminde bu section
 * Section Rendering API ile (/?sections=cart-drawer) yeniden cekilir; sayac,
 * toplam, agirlik ve kargo kademesi Liquid'de hesaplanir, JS yalnizca DOM'u degistirir.
 *
 * Disaridan tetikleme:
 *   document.dispatchEvent(new CustomEvent('hb:cart:added', { detail: { form, image } }))
 *   -> addToCart.js basarili /cart/add sonrasi gonderir; ucan gorsel animasyonu + yenileme.
 *   Form'da data-hb-open-cart varsa yenilemeden sonra modal acilir (trigger: after_add).
 */
(function () {
  "use strict";

  var root = document.querySelector("[data-hb-cart-drawer]");
  if (!root) return;

  var SECTION_ID = root.getAttribute("data-section-id") || "cart-drawer";
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var bar = root.querySelector("[data-hb-cart-bar]");
  var overlay = root.querySelector("[data-hb-cart-overlay]");
  var sheet = root.querySelector("[data-hb-cart-sheet]");
  var isOpen = false;
  var addedTimer = null;
  var closeMethod = "button";

  /* ---------------------------------------------------------------- events
     Tum etkilesimler GA4'e window.hbTrack (analytics.js) uzerinden gider.
     Amac: cubuk + modal oncesi/sonrasi farki net olcmek. Her event'e sepet
     durumu (item_count, value, shipping_tier) eklenir. */
  function cartState() {
    return {
      item_count: Number(root.getAttribute("data-item-count")) || 0,
      value: parseFloat(root.getAttribute("data-cart-value")) || 0,
      shipping_tier: root.getAttribute("data-ship-tier") || "none",
      shipping_price: Number(root.getAttribute("data-ship-price")) || 0
    };
  }
  function track(name, params) {
    if (!window.hbTrack) return;
    var p = cartState();
    if (params) for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
    window.hbTrack(name, p);
  }
  function cartItems() {
    var items = [];
    sheet.querySelectorAll("[data-hb-line]").forEach(function (line) {
      items.push({
        item_id: line.getAttribute("data-item-id"),
        item_name: line.getAttribute("data-item-name"),
        price: parseFloat(line.getAttribute("data-price")) || 0,
        quantity: Number(line.getAttribute("data-quantity")) || 0
      });
    });
    return items;
  }

  /* ---------------------------------------------------------------- open / close */
  function open(trigger) {
    if (isOpen) return;
    isOpen = true;
    overlay.hidden = false;
    sheet.hidden = false;
    // hidden kaldirildiktan sonra reflow zorla ki transition calissin
    // (rAF yerine: arka plandaki sekmede rAF askiya alinip acilis gecikebiliyor)
    void sheet.offsetHeight;
    overlay.classList.add("is-open");
    sheet.classList.add("is-open");
    document.documentElement.classList.add("hb-cart-lock");
    document.body.style.overflow = "hidden";
    var opener = root.querySelector("[data-hb-cart-open]");
    if (opener) opener.setAttribute("aria-expanded", "true");
    var closeBtn = sheet.querySelector(".hb-cart-sheet__close");
    if (closeBtn) closeBtn.focus({ preventScroll: true });
    var st = cartState();
    track("cart_drawer_open", { trigger: trigger || (st.item_count > 0 ? "bar" : "bar_empty") });
    // Standart GA4 view_cart; sepet sayfasindan ayirt etmek icin source parametresi
    if (st.item_count > 0) {
      track("view_cart", { currency: "TRY", items: cartItems(), source: "cart_drawer" });
    }
  }

  function close(method) {
    if (!isOpen) return;
    isOpen = false;
    track("cart_drawer_close", { method: method || closeMethod });
    closeMethod = "button";
    overlay.classList.remove("is-open");
    sheet.classList.remove("is-open");
    sheet.style.transform = "";
    document.body.style.overflow = "";
    document.documentElement.classList.remove("hb-cart-lock");
    var opener = root.querySelector("[data-hb-cart-open]");
    if (opener) opener.setAttribute("aria-expanded", "false");
    var delay = reduceMotion ? 0 : 420;
    setTimeout(function () {
      if (!isOpen) {
        overlay.hidden = true;
        sheet.hidden = true;
      }
    }, delay);
  }

  root.addEventListener("click", function (e) {
    if (e.target.closest("[data-hb-cart-open]")) {
      open();
      return;
    }
    var tracked = e.target.closest("[data-hb-track]");
    if (tracked) track(tracked.getAttribute("data-hb-track"), {});
    if (e.target.closest("[data-hb-cart-close]")) {
      // Link ise (ornek: "Urunlere goz at") once kapat, navigasyon devam etsin
      var m = e.target.closest("[data-hb-cart-overlay]") ? "overlay" : tracked ? "link" : "button";
      close(m);
      return;
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isOpen) close("escape");
  });

  /* ---------------------------------------------------------------- drag to close */
  (function enableDrag() {
    var startY = 0;
    var dy = 0;
    var dragging = false;

    function onStart(e) {
      var handle = e.target.closest("[data-hb-cart-handle]");
      if (!handle) return;
      dragging = true;
      dy = 0;
      startY = (e.touches ? e.touches[0] : e).clientY;
      sheet.classList.add("is-dragging");
    }
    function onMove(e) {
      if (!dragging) return;
      var y = (e.touches ? e.touches[0] : e).clientY;
      dy = Math.max(0, y - startY);
      sheet.style.transform = "translateY(" + dy + "px)";
      if (dy > 0) e.preventDefault();
    }
    function onEnd() {
      if (!dragging) return;
      dragging = false;
      sheet.classList.remove("is-dragging");
      if (dy > 90) {
        close("drag");
      } else {
        sheet.style.transform = "";
      }
    }
    sheet.addEventListener("touchstart", onStart, { passive: true });
    sheet.addEventListener("touchmove", onMove, { passive: false });
    sheet.addEventListener("touchend", onEnd);
    sheet.addEventListener("touchcancel", onEnd);
  })();

  /* ---------------------------------------------------------------- refresh from section */
  function refresh() {
    return fetch(ROOT_URL + "?sections=" + SECTION_ID, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var html = json && json[SECTION_ID];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-hb-cart-drawer]");
        if (!fresh) return;

        // Cubuk: sinif (bos/dolu) + icerik
        var freshBar = fresh.querySelector("[data-hb-cart-bar]");
        if (freshBar && bar) {
          bar.className = freshBar.className + (bar.classList.contains("is-added") ? " is-added" : "");
          var btn = bar.querySelector("[data-hb-cart-open]");
          var freshBtn = freshBar.querySelector("[data-hb-cart-open]");
          if (btn && freshBtn) btn.innerHTML = freshBtn.innerHTML;
        }

        // Modal: baslik sayaci, govde, alt butonlar
        var count = sheet.querySelector("[data-hb-cart-count]");
        var freshCount = fresh.querySelector("[data-hb-cart-count]");
        if (count && freshCount) count.innerHTML = freshCount.innerHTML;

        var body = sheet.querySelector("[data-hb-cart-body]");
        var freshBody = fresh.querySelector("[data-hb-cart-body]");
        if (body && freshBody) {
          // Not blogu yerinde kalsin: yazilan (henuz kaydedilmemis olabilir) metin, acik/kapali durum ve odak korunur
          var liveNote = body.querySelector("[data-hb-note]");
          var hadFocus = liveNote && liveNote.contains(document.activeElement);
          body.innerHTML = freshBody.innerHTML;
          var slot = body.querySelector("[data-hb-note]");
          if (liveNote && slot) {
            slot.replaceWith(liveNote);
            if (hadFocus) {
              var input = liveNote.querySelector("[data-hb-note-input]");
              if (input) input.focus({ preventScroll: true });
            }
          }
        }

        var foot = sheet.querySelector(".hb-cart-sheet__foot");
        var freshFoot = fresh.querySelector(".hb-cart-sheet__foot");
        if (foot && !freshFoot) foot.remove();
        else if (!foot && freshFoot) sheet.appendChild(freshFoot);
        else if (foot && freshFoot) foot.innerHTML = freshFoot.innerHTML;

        ["data-item-count", "data-total-weight", "data-cart-value", "data-ship-tier", "data-ship-price"].forEach(function (a) {
          root.setAttribute(a, fresh.getAttribute(a) || "");
        });

        // Header'daki eski sayac rozetleri de ayni kalsin
        var n = root.getAttribute("data-item-count");
        document.querySelectorAll(".cart-count").forEach(function (el) {
          // header.liquid rozeti 0'da bos birakir; ayni davranisi koru
          el.textContent = Number(n) > 0 ? n : "";
          if (Number(n) > 0) el.classList.add("items");
          else el.classList.remove("items");
        });
      })
      .catch(function () { /* sessiz: bir sonraki degisimde tekrar denenir */ });
  }

  /* ---------------------------------------------------------------- quantity / remove */
  function trackChange(line, eventName, qty) {
    if (!window.hbTrack || !line) return;
    var price = parseFloat(line.getAttribute("data-price")) || 0;
    window.hbTrack(eventName, {
      currency: "TRY",
      value: price * qty,
      source: "cart_drawer",
      items: [{
        item_id: line.getAttribute("data-item-id"),
        item_name: line.getAttribute("data-item-name"),
        price: price,
        quantity: qty
      }]
    });
  }

  sheet.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-hb-qty-change]");
    if (!btn) return;
    var line = btn.closest("[data-hb-line]");
    if (!line || line.classList.contains("is-busy")) return;

    var key = line.getAttribute("data-key");
    var current = Number(line.getAttribute("data-quantity")) || 0;
    var next = Math.max(0, Number(btn.getAttribute("data-hb-qty-change")));
    if (next === current) return;

    track("cart_drawer_qty_change", {
      action: next === 0 ? "remove" : next > current ? "increase" : "decrease",
      item_id: line.getAttribute("data-item-id"),
      quantity_from: current,
      quantity_to: next
    });

    line.classList.add("is-busy");
    fetch(ROOT_URL + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: next })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        if (next > current) trackChange(line, "add_to_cart", next - current);
        else trackChange(line, "remove_from_cart", current - next);
        return refresh();
      })
      .catch(function () {
        line.classList.remove("is-busy");
      });
  });

  /* ---------------------------------------------------------------- order note
     cart.note -> siparis notu. Yazmayi birakinca (600 ms) ve alandan cikinca kaydedilir;
     "Odemeye Gec" kaydedilmemis not varsa once kaydeder. Not icerigi GA4'e gonderilmez. */
  var NOTE_MAX = 300;
  var noteTimer = null;
  var noteSaving = null;

  function noteEls() {
    var wrap = sheet.querySelector("[data-hb-note]");
    if (!wrap) return null;
    return {
      wrap: wrap,
      input: wrap.querySelector("[data-hb-note-input]"),
      label: wrap.querySelector("[data-hb-note-label]"),
      count: wrap.querySelector("[data-hb-note-count]"),
      status: wrap.querySelector("[data-hb-note-status]"),
      toggle: wrap.querySelector("[data-hb-note-toggle]")
    };
  }
  function noteSaved(n) {
    // Son kaydedilen deger; ilk etkilesimde Liquid'in basdigi deger
    if (n.wrap.dataset.saved === undefined) n.wrap.dataset.saved = n.input.defaultValue;
    return n.wrap.dataset.saved;
  }
  function noteDirty() {
    var n = noteEls();
    return !!n && n.input.value !== noteSaved(n);
  }
  function setNoteStatus(n, text, cls) {
    n.status.textContent = text;
    n.status.className = "hb-note__status" + (cls ? " " + cls : "");
  }
  function renderNoteLabel(n) {
    var v = n.input.value.trim();
    n.label.textContent = "";
    if (v) {
      n.label.appendChild(document.createTextNode("Notunuz: "));
      var s = document.createElement("span");
      s.className = "hb-note__preview";
      s.textContent = v;
      n.label.appendChild(s);
    } else {
      n.label.textContent = "Sipariş notu ekle";
    }
  }

  function saveNote() {
    clearTimeout(noteTimer);
    var n = noteEls();
    if (!n || !noteDirty()) return noteSaving || Promise.resolve();
    var value = n.input.value;
    setNoteStatus(n, "Kaydediliyor…");
    noteSaving = fetch(ROOT_URL + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ note: value }),
      keepalive: true
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        n.wrap.dataset.saved = value;
        if (n.input.value === value) setNoteStatus(n, "✓ Kaydedildi", "is-ok");
        track("cart_drawer_note_saved", { note_length: value.trim().length });
      })
      .catch(function () {
        setNoteStatus(n, "Kaydedilemedi, tekrar deneyin", "is-err");
      })
      .then(function () { noteSaving = null; });
    return noteSaving;
  }

  sheet.addEventListener("click", function (e) {
    if (!e.target.closest("[data-hb-note-toggle]")) return;
    var n = noteEls();
    var opening = !n.wrap.classList.contains("is-open");
    n.wrap.classList.toggle("is-open", opening);
    n.toggle.setAttribute("aria-expanded", opening ? "true" : "false");
    if (opening) {
      n.input.focus({ preventScroll: true });
      // Klavye acilinca alan gorunur kalsin
      setTimeout(function () { n.input.scrollIntoView({ block: "nearest", behavior: reduceMotion ? "auto" : "smooth" }); }, 320);
      track("cart_drawer_note_open", { has_note: n.input.value.trim() ? 1 : 0 });
    } else {
      renderNoteLabel(n);
      saveNote();
    }
  });

  sheet.addEventListener("input", function (e) {
    if (!e.target.closest("[data-hb-note-input]")) return;
    var n = noteEls();
    n.count.textContent = n.input.value.length + "/" + NOTE_MAX;
    setNoteStatus(n, "");
    clearTimeout(noteTimer);
    noteTimer = setTimeout(saveNote, 600);
  });

  sheet.addEventListener("focusout", function (e) {
    if (!e.target.closest("[data-hb-note-input]")) return;
    renderNoteLabel(noteEls());
    saveNote();
  });

  // Odemeye gec: kaydedilmemis not varsa once kaydet (en fazla 2 sn bekle), sonra git
  sheet.addEventListener("click", function (e) {
    var link = e.target.closest('[data-hb-track="cart_drawer_checkout"]');
    if (!link || (!noteDirty() && !noteSaving)) return;
    e.preventDefault();
    var go = function () { window.location.href = link.href; };
    Promise.race([saveNote(), new Promise(function (r) { setTimeout(r, 2000); })]).then(go, go);
  });

  /* ---------------------------------------------------------------- add-to-cart animation */
  function flyToBar(imgEl) {
    var target = bar && bar.querySelector("[data-hb-cart-target]");
    if (!imgEl || !target || reduceMotion || bar.classList.contains("hb-cart-bar--hidden")) return Promise.resolve();
    if (window.innerWidth >= 768) return Promise.resolve();

    var from = imgEl.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !to.width) return Promise.resolve();

    var ghost = document.createElement("img");
    ghost.className = "hb-fly";
    ghost.src = imgEl.currentSrc || imgEl.src;
    ghost.alt = "";
    var size = Math.min(from.width, from.height, 96);
    ghost.style.width = size + "px";
    ghost.style.height = size + "px";
    ghost.style.left = from.left + from.width / 2 - size / 2 + "px";
    ghost.style.top = from.top + from.height / 2 - size / 2 + "px";
    document.body.appendChild(ghost);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);
    var scale = (to.width * 0.6) / size;

    // Yumusak kavis: once hafif yukari suzul, sonra cubuga in
    var anim = ghost.animate(
      [
        { transform: "translate(0,0) scale(1) rotate(0deg)", opacity: 1, offset: 0 },
        { transform: "translate(" + dx * 0.35 + "px," + (dy * 0.15 - 40) + "px) scale(0.85) rotate(-4deg)", opacity: 1, offset: 0.4 },
        { transform: "translate(" + dx + "px," + dy + "px) scale(" + scale + ") rotate(3deg)", opacity: 0.2, offset: 1 }
      ],
      { duration: 720, easing: "cubic-bezier(0.22, 1, 0.36, 1)", fill: "forwards" }
    );
    return new Promise(function (resolve) {
      anim.onfinish = function () { ghost.remove(); resolve(); };
      anim.oncancel = function () { ghost.remove(); resolve(); };
    });
  }

  function bumpBar() {
    if (!bar) return;
    bar.classList.remove("is-bump");
    void bar.offsetWidth; // animasyonu yeniden baslat
    bar.classList.add("is-bump");
    var btn = bar.querySelector("[data-hb-cart-open]");
    if (btn && !reduceMotion) {
      var ripple = document.createElement("span");
      ripple.className = "hb-cart-bar__ripple";
      btn.appendChild(ripple);
      setTimeout(function () { ripple.remove(); }, 750);
    }
    bar.classList.add("is-added");
    clearTimeout(addedTimer);
    addedTimer = setTimeout(function () { bar.classList.remove("is-added"); }, 2200);
    setTimeout(function () { bar.classList.remove("is-bump"); }, 700);
  }

  document.addEventListener("hb:cart:added", function (e) {
    var d = (e && e.detail) || {};
    var img = d.image;
    if (!img && d.form) {
      var card = d.form.closest("[data-variant-id]") || d.form;
      img = card.querySelector("img");
      if (!img) {
        // Urun sayfasi: form gorseli icermez, sayfadaki ana urun gorselini kullan
        img = document.querySelector(".product-image img, .swiper-slide-active img, main img");
      }
    }
    flyToBar(img).then(function () {
      bumpBar();
    });
    refresh().then(function () {
      track("cart_bar_add_feedback", { page: document.body.getAttribute("data-template") || location.pathname.split("/")[1] || "home" });
      // Sepet cubugunun gizli oldugu sayfalar (urun akisi) geri bildirimi modalla verir;
      // icerik guncellendikten sonra acilir ki yeni urun ve kargo kademesi gorunsun
      // (masaustunde modal display:none — acma, sayfa kilidi ve sahte cart_drawer_open olmasin)
      if (d.form && d.form.hasAttribute("data-hb-open-cart") && getComputedStyle(root).display !== "none") open("after_add");
    });
  });

  // Sepet sayfasindaki cart.js degisiklikleri icin de guncel kal
  document.addEventListener("hb:cart:updated", function () { refresh(); });
})();
